import { useEffect, useState } from "react";
import { useRecoilState } from "recoil";
import getCountryAPI from "../api/getCountryAPI";
import { countryAtom } from "../atoms/country";
import { getLanguage } from "../utils/LanguageUtils";

const requestCountryFromServer = async () => {
  const lang = getLanguage();
  return getCountryAPI({ language: [lang] })
    .then((res) => {
      switch (+res.data.code) {
        case 200:
          return res.data.country;
        default:
          return "US";
      }
    })
    .catch(() => {
      return "US";
    });
};

const useCountry = (): string => {
  return useRecoilState(countryAtom)[0];
};

export const CountryProvider = (props: {
  children: JSX.Element;
  loading: JSX.Element;
}) => {
  const { children, loading } = props;
  const [countryFromServer, setCountryFromServer] = useState<string | null>(
    () => {
      try {
        const cached: unknown = JSON.parse(
          localStorage.getItem("sgg_country") || "null",
        );
        return typeof cached === "string" && /^[A-Z]{2}$/.test(cached)
          ? cached
          : null;
      } catch {
        return null;
      }
    },
  );
  const [country, setCountry] = useRecoilState(countryAtom);
  const envCountry = import.meta.env.VITE_GG_COUNTRY;
  const urlCountry = new URLSearchParams(window.location.search)
    .get("setcountry")
    ?.toUpperCase();

  useEffect(() => {
    let active = true;

    if (!envCountry && !urlCountry) {
      requestCountryFromServer().then((result) => {
        if (active) {
          setCountryFromServer(result);
        }
      });
    }

    return () => {
      active = false;
    };
  }, []);

  const providedCountry = envCountry || urlCountry || countryFromServer;

  useEffect(() => {
    if (providedCountry) setCountry(providedCountry);
  }, [providedCountry]);

  if (!providedCountry || country !== providedCountry) {
    return loading;
  }
  return children;
};

export default useCountry;
